import { useMemo } from 'react';

export default function useTextMaxLenght(text: string, fontSize: number, maxChars: number) {
  const fontChWide = useMemo(() => {
    return fontSize / 2;
  }, [fontSize]);

  const needTooltip = useMemo(() => {
    return text.length * fontChWide > maxChars * fontChWide;
  }, [text, fontChWide, maxChars]);

  const newText = useMemo(() => {
    if (needTooltip) {
      return text.slice(0, maxChars - 3) + '...';
    }
    return text;
  }, [needTooltip, text, maxChars]);

  return { needTooltip, newText };
}
